/* TODO: t() */
import Leaflet from 'leaflet';

const DEFAULT_LAT = 0;
const DEFAULT_LNG = 0;
const DEFAULT_ZOOM_LEVEL = 9;

export type ViewStateDesc = {
  lat?: number;
  lng?: number;
  zoomLevel?: number;
};

export default class ViewState {
  lat: number;
  lng: number;
  zoomLevel: number;

  constructor(viewState: ViewStateDesc) {
    this.lat = viewState.lat != null ? viewState.lat : DEFAULT_LAT;
    this.lng = viewState.lng != null ? viewState.lng : DEFAULT_LNG;
    this.zoomLevel =
      viewState.zoomLevel != null ? viewState.zoomLevel : DEFAULT_ZOOM_LEVEL;
  }

  getPixelsPerUnit(zoomLevel: number): number {
    if (zoomLevel == null) {
      zoomLevel = this.zoomLevel;
    }
    return Leaflet.CRS.Simple.scale(zoomLevel);
  }
}
